// src/tabs/calendar/_block-visual.js — Phase 6.D PR #169a v1.4 (ADR-104)
//
// Helper distinction visuelle calendrier pricing_blocks :
//   - guest_first_name NULL    → blocage simple (travaux, indispo) → gris srcBloque
//   - guest_first_name NOT NULL → résa direct interne FBZ          → vert srcDirect
//
// DA (DESIGN.md §8 bis) — décision de couleur actée : la sous-location interne
// FBZ est FUSIONNÉE avec « Direct » en VERT (`srcDirect` #1D9E75) — l'ancien
// violet pastel #ddd6fe est abandonné. Une résa direct interne EST une résa
// directe : même vert que la source `direct`. La période bloquée (sans
// voyageur) prend le gris neutre de source `srcBloque` #b0b6c0.
// Le vert reste distinct des autres sources (Airbnb #E8632E, Booking #215387)
// et du proprio pastel #a8f0c0.
//
// Préfixe `_` = convention internal-module (cohérent _source-colors.js,
// _block-helpers.js, _min-stay-helpers.js etc.).
//
// Consommateurs : TableauView.jsx (deux sub-rows pricing + min_stay) + TodayView.jsx
// (badge direct interne). MensuelView retirée PR #169d.

// Couleur blocage simple — gris neutre de source (DS.srcBloque).
export const BLOCK_BG_EMPTY = "#b0b6c0"; // DS.srcBloque (période bloquée)

// Couleur résa direct interne FBZ — vert de source Direct (DS.srcDirect).
export const BLOCK_BG_DIRECT = "#1D9E75"; // DS.srcDirect (fusionné avec Direct)

// Icône commune aux deux états (sémantique : période bloquée).
export const BLOCK_ICON = "🔒";

/**
 * Distinction visuelle blocage simple vs résa direct interne FBZ.
 *
 * @param {object|null} block — entrée pricing_blocks (depuis use-daily-pricing).
 *   Doit contenir : guest_first_name (string ou null).
 * @returns {{ kind: 'empty'|'direct'|null, bgColor: string|null, icon: string|null, isDirect: boolean }}
 *
 * Edge cases :
 *   - block null/undefined → kind=null, bgColor=null, icon=null, isDirect=false
 *   - block.guest_first_name '' (chaîne vide) ou null → kind='empty', isDirect=false
 *   - block.guest_first_name avec espaces seuls → traités comme vide (trim)
 */
export function getBlockVisualState(block) {
  if (!block) {
    return { kind: null, bgColor: null, icon: null, isDirect: false };
  }
  const firstName = block.guest_first_name;
  const isDirect =
    typeof firstName === "string" && firstName.trim() !== "";
  return {
    kind: isDirect ? "direct" : "empty",
    bgColor: isDirect ? BLOCK_BG_DIRECT : BLOCK_BG_EMPTY,
    icon: BLOCK_ICON,
    isDirect,
  };
}
